import { gql } from '@apollo/client'

export const GET_ONE_ROUTE_BY_CONTEXT_USER_ID = gql`
  query GetOneRouteByContextUserId {
    getOneRouteByContextUserId {
      routes {
        id
        user_id
        truck_id
        provider_id
        scheduled_date
        frequency
        frequency_spanish
        status_id
        RouteToUser {
          id
          name
          first_name
          last_name
        }
        RouteToTrucks {
          id
          plate_number
          type
          capacity
          status
        }
        RouteToRoutePoints {
          id
          route_id
          water_station_id
          water_truck_request_id
          loaded_volume
          loaded_at
          delivered_at
          RoutePointsToRoute {
            id
            user_id
            truck_id
            provider_id
            scheduled_date
            frequency
            frequency_spanish
          }
          RoutePointsToWaterStation {
            id
            name
            location
            address
            status
            operating_hours
            manager
            contact_info
          }
          RoutePointsToWaterTruckRequest {
            id
            volume
            priority
            type_delivery
            status_id
            provider_id
            folio
            planning_date
            completed_at
            StatusOfWaterTruckRequest {
              id
              name
            }
            AddressOfWaterTruckRequest {
              id
              latitude
              longitude
              address_full
            }
          }
        }
      }
      completedPoints
      totalPoints
    }
  }
`

export const UPDATE_POINT_ROUTE_FROM_WATER_DRIVER = gql`
  mutation WaterDriverUpdatePointOfRouteAndWaterTruckRequest(
    $input: updatePointOfRouteAndWaterTruckRequestInput!
  ) {
    waterDriverUpdatePointOfRouteAndWaterTruckRequest(input: $input)
  }
`

export const COMPLETE_POINT_ROUTE_FROM_WATER_DRIVER = gql`
  mutation WaterDriverCompletePointOfRouteAndWaterTruckRequest(
    $input: waterDriverCompletePointOfRouteAndWaterTruckRequestInput!
  ) {
    waterDriverCompletePointOfRouteAndWaterTruckRequest(input: $input)
  }
`

export const FINISH_ROUTE_FROM_WATER_DRIVER = gql`
  mutation WaterDriverFinishRouteAndWaterTruckRequest($route_id: Int!) {
    waterDriverFinishRouteAndWaterTruckRequest(route_id: $route_id)
  }
`
